/*=================================================;
/* PRODUCT GALLERY SLIDER
/*================================================= */
function productGallery() {
    const product_thumbnails = document.querySelector('.js-product-thumbnails');
 
    if (product_thumbnails == null) {
       return false;
    }
 
    const product_gallery_thumbnails = new Swiper('.js-product-thumbnails', {
       centerInsufficientSlides: product_thumbnails.getAttribute('data-position') === '1',
       direction: 'horizontal',
       spaceBetween: 10,
       navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
       },
       breakpoints: {
          0: {
             direction: 'horizontal',
             slidesPerView: 5,
             centerInsufficientSlides: true,
          },
          992: {
             direction: product_thumbnails.getAttribute('data-direction'),
             slidesPerView: product_thumbnails.getAttribute('data-direction') == 'horizontal' ? 7 : 5,
          },
       },
    });
 
    const product_gallery_dislay = new Swiper('.js-product-image', {
       spaceBetween: 10,
       pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
       },
    });
 
    // highlight first thumbnail on load
    product_gallery_thumbnails.slides[0].classList.add('swiper-slide-thumb-active');
 
    // sync thumbnails active state and scroll position when display slide changes
    product_gallery_dislay.on('slideChange', function () {
       const slides = product_gallery_thumbnails.slides;
       let i;
 
       for (i = 0; i < slides.length; i++) {
          slides[i].classList.remove('swiper-slide-thumb-active');
       }
 
       slides[product_gallery_dislay.activeIndex].classList.add('swiper-slide-thumb-active');
       product_gallery_thumbnails.slideTo(product_gallery_dislay.activeIndex, 300);
    });
 
    // navigate display slider straight to the clicked thumbnail
    product_gallery_thumbnails.slides.forEach(function (slide, index) {
       slide.addEventListener('click', function (event) {
          const link = event.target.closest ? event.target.closest('a') : null;
 
          if (link !== null) {
             event.preventDefault();
          }
 
          product_gallery_dislay.slideTo(index, 300);
          product_gallery_thumbnails.slideTo(index, 300);
       });
    });
 
    jQuery(document).on('found_variation', 'form.variations_form', function (event, variation) {
       // back to first main image
       product_gallery_thumbnails.slideTo(0, 700);
       product_gallery_dislay.slideTo(0, 700);
    });
 }
 productGallery();
 
 /*=================================================;
 /* lIST LIGHTBOX IMAGE
 /*================================================= */
 // create lightbox list from all product image
 // set global product image array
 let product_lightbox_items = [];
 
function productGalleryItems() {
   const elements = document.querySelectorAll('.js-product-lightbox');
   elements.forEach(function (element) {
      // skip video slide, only image added to photoswipe list
      if (element.querySelector('video') !== null) {
         return;
      }

      const link = element.querySelector('a');

      if (link == null) {
         return;
      }

      const items = {
         src: link.getAttribute('href'),
         w: link.getAttribute('width'),
         h: link.getAttribute('height'),
      };
      product_lightbox_items.push(items);
   });
}
productGalleryItems();

/*=================================================;
/* LIGHTBOX ACTION
/*================================================= */
// Ligtbox gallery action
// show ligtbox if user click a image gallery display
function productLightbox() {
   const trigger = document.querySelectorAll('.js-product-lightbox a');
   // list of image links aligned with product_lightbox_items order
   const image_links = [];

   document.querySelectorAll('.js-product-lightbox').forEach(function (element) {
      if (element.querySelector('video') !== null) {
         return;
      }

      const link = element.querySelector('a');

      if (link !== null) {
         image_links.push(link);
      }
   });

   trigger.forEach(function (element) {
      element.addEventListener('click', function (event) {
         event.preventDefault();

         // open video zoom
         if (element.closest('.woocommerce-product-gallery__video')) {
            productVideoLightbox(element.getAttribute('href'));
            return;
         }

         // Define object and gallery options
         // arg index,create start lightbox image form image click
         const lightbox = document.querySelectorAll('.pswp')[0];
         const options = {
            index: image_links.indexOf(element),
            bgOpacity: 0.85,
            showHideOpacity: true,
         };
         // Initialize PhotoSwipe
         const gallery = new PhotoSwipe(lightbox, PhotoSwipeUI_Default, product_lightbox_items, options);
         gallery.init();
      });
   });
}
productLightbox();



/*=================================================;
 /* VIDEO LIGHTBOX ACTION
/*================================================= */
// show video zoom if user click a video gallery display
function productVideoLightbox(videoSrc) {
   const overlay = document.createElement('div');

   overlay.className = 'rt-video-lightbox';
   overlay.innerHTML = '<button type="button" class="rt-video-lightbox__close" aria-label="Close">&times;</button><video class="rt-video-lightbox__video" src="' + videoSrc + '" controls playsinline></video>';

   document.body.appendChild(overlay);
   document.querySelector('html').style.overflowY = 'hidden';

   function onKeydown(event) {
      if (event.key === 'Escape') {
         closeLightbox();
      }
   }

   function closeLightbox() {
      overlay.remove();
      document.querySelector('html').style.overflowY = 'auto';
      document.removeEventListener('keydown', onKeydown, false);
   }

   overlay.addEventListener('click', function (event) {
      if (event.target === overlay || event.target.classList.contains('rt-video-lightbox__close')) {
         closeLightbox();
      }
   });

   document.addEventListener('keydown', onKeydown, false);
}
 
 /*=================================================;
 /* VARIABLE SELECT
 /*================================================= */
 /**
  * Change image thumbnails if variation select
  */
 jQuery(document).on('found_variation', 'form.variations_form', function (event, variation) {
    // rebuild array list if change image
    if (product_lightbox_items[0]) {
       product_lightbox_items[0].src = variation.image.full_src;
    }
 });
 
 /*=================================================;
 /* PRODUCT STICKY
 /*================================================= */
 /**
  * Floating sticky product action if windows scroling down
  */
 function productSticky() {
    const body = document.querySelector('body');
    const element = document.querySelector('.js-sticky-product');
    const trigger = document.querySelector('.rt-product-summary form .button');
 
    if (element == null) {
       return false;
    }
 
    let position = 500;
 
    if (trigger !== null) {
       position = trigger.offsetTop + 400;
    }
 
    if (document.body.scrollTop > position || document.documentElement.scrollTop > position) {
       element.classList.add('is-sticky');
       body.classList.add('sticky-product');
    } else {
       element.classList.remove('is-sticky');
       body.classList.remove('sticky-product');
    }
 }
 window.addEventListener('scroll', productSticky);
 